<div class="p-6 max-w-lg mx-auto bg-white shadow rounded-lg">
  <h2 class="text-xl font-semibold mb-4">
    {{ isEdit ? 'Edit Category' : 'Add Category' }}
  </h2>

  <form [formGroup]="categoryForm" (ngSubmit)="onSubmit()" class="space-y-4">
    <div>
      <label class="block mb-1 font-medium">Name</label>
      <input formControlName="name"
             class="w-full border rounded p-2 focus:ring focus:ring-green-300" />
      <div *ngIf="categoryForm.get('name')?.invalid && categoryForm.get('name')?.touched"
           class="text-red-600 text-sm">Name is required</div>
    </div>

    <div>
      <label class="block mb-1 font-medium">Parent Category</label>
      <select formControlName="parentId"
              class="w-full border rounded p-2 focus:ring focus:ring-green-300">
        <option [ngValue]="null">-- None --</option>
        <option *ngFor="let cat of categories" [ngValue]="cat.id">{{ cat.name }}</option>
      </select>
    </div>

    <button type="submit"
            class="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded w-full">
      {{ isEdit ? 'Update Category' : 'Create Category' }}
    </button>
  </form>
</div>
